import clsx from 'clsx'

import type { Event } from '@/services/api/schemas/events'
import { getEventTitle } from '@/shared/lib/eventTypes'
import { formatDate, formatTime } from '@/shared/lib/format'

import s from './EventRow.module.css'
import { EventTypeIcon } from './EventTypeIcon'

interface EventRowProps {
  event: Event
  selected?: boolean
  onClick: (event: Event) => void
}

export function EventRow({ event, selected, onClick }: EventRowProps) {
  return (
    <button
      type="button"
      className={clsx(s.row, selected && s.selected)}
      onClick={() => onClick(event)}
      aria-current={selected ? 'true' : undefined}
    >
      <EventTypeIcon type={event.type} />
      <span>
        <div className={s.title}>{getEventTitle(event)}</div>
        <div className={s.id}>{event.id}</div>
      </span>
      <span className={s.when}>
        <b>{formatTime(event.detected_at)}</b>
        {formatDate(event.detected_at)}
      </span>
    </button>
  )
}
